import axios from 'axios'

export const getProjects = (params) => {
  return axios.get('projects', { params: params })
}

export const getProject = (params) => {
  return axios.get('project/show', { params: params })
}

export const getTour = (id) => {
  return axios.get('tours/' + id)
}

export const createProject = (data) => {
  return axios.post('project/create', data)
}

export const editProject = (id, data) => {
  return axios.post('project/edit/' + id, data)
}

export const duplicateProject = (id) => {
  return axios.post('project/duplicate/' + id)
}

export const deleteProject = (id) => {
  return axios.post('project/delete/' + id)
}

export const updateCategory = (projectId, data) => {
  return axios.post('category/update/' + projectId, data)
}

export const toggleLockProject = (projectId, data) => {
  return axios.post('project/public/' + projectId, data)
}

export const uploadAsset = (projectId, data) => {
  return axios.post('project/upload-asset/' + projectId, data)
}

export const changeCover = (projectId, data) => {
  return axios.post('project/change-cover/' + projectId, data)
}

export const updateMaintenanceMode = (projectId, data) => {
  return axios.post('project/maintenance-mode/' + projectId, data)
}

export const getTours = (params) => {
  return axios.get('tours', { params: params })
}



// WEBPACK FOOTER //
// ./src/api/projects.js